import api from './api';

function downloadBlob(response, fallbackName) {
  const disposition = String(response.headers?.['content-disposition'] || '');
  const match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  let fileName = fallbackName;
  if (match) {
    try { fileName = decodeURIComponent(match[1]); } catch (_) { /* use fallback */ }
  }
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const objectsService = {
  getSummary: () => api.get('/objects/summary').then(response => response.data),
  getAll: (params = {}) => api.get('/objects', { params }).then(response => response.data),
  getById: id => api.get(`/objects/${id}`).then(response => response.data),
  create: data => api.post('/objects', data).then(response => response.data),
  update: (id, data) => api.put(`/objects/${id}`, data).then(response => response.data),
  archive: id => api.delete(`/objects/${id}`).then(response => response.data),
  addEquipment: (objectId, data) => api.post(`/objects/${objectId}/equipment`, data).then(response => response.data),
  updateEquipment: (objectId, equipmentId, data) => api.put(`/objects/${objectId}/equipment/${equipmentId}`, data).then(response => response.data),
  dismantleEquipment: (objectId, equipmentId) => api.delete(`/objects/${objectId}/equipment/${equipmentId}`).then(response => response.data),
  uploadFile: (objectId, { file, title, category, notes }) => {
    const data = new FormData();
    data.append('file', file);
    data.append('title', title || '');
    data.append('category', category || 'other');
    data.append('notes', notes || '');
    return api.post(`/objects/${objectId}/files`, data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => response.data);
  },
  deleteFile: (objectId, fileId) => api.delete(`/objects/${objectId}/files/${fileId}`),
  downloadFile: async (objectId, fileId, fallbackName = `Документ-${fileId}`) => {
    const response = await api.get(`/objects/${objectId}/files/${fileId}/download`, { responseType: 'blob' });
    downloadBlob(response, fallbackName);
  },
};
